module.exports = __webpack_public_path__ + "36686dffcdfc8c68c89cf4cbeb264984.svg";